import { HTTP } from './helpers/http.js'

export default {
  getAllCountryCodes(organizationId) {
    const url = `api/v1/organizations/${organizationId}/country-codes`
    return HTTP.get(url)
  },
}
